import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>; // You can replace with a proper loading component
  }

  return isAuthenticated() ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;